'use strict';
var $ = require('jquery');
var Backbone = require('backbone');
var _ = require('underscore');
var Common = require('../common');

module.exports = Backbone.View.extend({

    initialize: function () {
        console.log('Initializing SelectBuildingEntryView');
    },

    events: {
        "click #selectBuildingEntry": "selectBuilding"
    },

    template: _.template($('#selectBuildingEntry-template').html(), { interpolate: /\{\{(.+?)\}\}/g }),

    render: function () {
        $(this.el).html(this.template(this.model.attributes));
        return this;
    },

    selectBuilding: function (e) {
        e.preventDefault();
        console.log('SelectBuildingEntry View: selectBuilding');
        Common.Buildings.setActive(this.model);
        Common.Router.navigate("#", { trigger: true });
    },

    destroy: function () {
        this.remove();
        this.model.off('change');

        // Remove the validation binding
        // See: http://thedersen.com/projects/backbone-validation/#using-form-model-validation/unbinding
        Backbone.Validation.unbind(this);
        return Backbone.View.prototype.remove.apply(this, arguments);
    }
});